module.exports = __webpack_public_path__ + "static/media/conf-app0.0341c2f4.png";